import { DemoUserObject } from "assets/data/usersData";
import { CustomComponentProps } from "utils/types/generalTypes";
import { usersArray } from "assets/data/usersData";
import { useState } from "react";
import { Button, IconInput } from "ui";
import userIcon from "assets/img/user_icon.png";

export type SignupForm5Props = CustomComponentProps & {
    followedUsers: DemoUserObject[];
    setFollowedUsers: React.Dispatch<React.SetStateAction<DemoUserObject[]>>;
    changeStep: React.Dispatch<React.SetStateAction<number>>;
    step: number;
};

const SignupForm5 = ({
    followedUsers,
    setFollowedUsers,
    changeStep,
    step,
    className,
    style
}: SignupForm5Props) => {
    const [filter, setFilter] = useState("");
    const [filteredUsers, setFilterdUsers] = useState(usersArray);

    const filterUsers = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
        const val = e.target.value.toLowerCase();
        const tempFilteredArr = usersArray.filter(
            (i) => i.name.toLowerCase().indexOf(val) > -1
        );
        setFilterdUsers(tempFilteredArr);
    };

    const toggleUser = (user: DemoUserObject) => {
        if (followedUsers.includes(user)) {
            const newArr = followedUsers.filter((u) => u != user);
            setFollowedUsers(newArr);
        } else {
            setFollowedUsers([...followedUsers, user]);
        }
    };

    return (
        <div
            id="signup-panel-5"
            className={`process-panel-wrap is-narrow ${className} ${step == 4 ? "is-active" : ""}`}
            style={style}
        >
            <div className="form-panel">
                <IconInput
                    value={filter}
                    handleChange={filterUsers}
                    rounded={true}
                />
                <div className="field follow-users-field">
                    <ul
                        className="follow-users-ul d-flex flex-col gap-15"
                        id="sign-up-follow-user-ul"
                    >
                        {filteredUsers.map((user) => (
                            <li className="follow-user-li" key={user.id}>
                                <div className="d-flex flex-j-between">
                                    <div className="d-flex flex-j-start">
                                        <img
                                            src={user.url || userIcon}
                                            alt={user.name}
                                        />
                                        <div className="follow-user-li-text d-flex flex-col flex-a-start flex-j-center pl-10">
                                            <h3>
                                                <a
                                                    href="#"
                                                    className="dark-grey-text white-text"
                                                >
                                                    {user.name.length > 10
                                                        ? `${user.name.slice(0, 10)}...`
                                                        : user.name}
                                                </a>
                                            </h3>
                                            <span className="momeento-p">
                                                @{user.username}
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="follow-btn d-flex flex-j-center flex-a-center pl-10"
                                        onClick={() => toggleUser(user)}
                                    >
                                        <div
                                            className={`momeento-svg ${followedUsers.includes(user) ? "followed-svg" : "follow-svg"}  follow-user-svg transition-svg`}
                                        ></div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="buttons">
                <Button
                    text="Back"
                    handleClick={() => changeStep(step - 1)}
                    color=""
                />
                <Button text="Next" handleClick={() => changeStep(step + 1)} />
            </div>
        </div>
    );
};

export default SignupForm5;
